import { PaymentProviderBankDetails } from './bank-account';
import { OnboardingDetails } from './onboarding';

export interface BankPaymentOption {
  [uuid: string]: PaymentProviderBankDetails
}

export interface CardPaymentOption {
  [uuid: string]: {
    card_last_4: string;
  }
}

export interface PaymentOption {
  id: string;
  type: 'card' | 'bank';
}

export enum MoovCardTypes {
  DEBIT = 'debit',
  CREDIT = 'credit',
  PREPAID = 'prepaid',
  UNKNOWN = 'unknown'
}

export interface MoovCard {
  // There are other fields returned, but are irrelevant for our case
  cardID: string;
  lastFourCardNumber: string;
  cardType: MoovCardTypes
}

export interface PaymentOptionsStoreState {
  default: PaymentOption;
  cards: CardPaymentOption;
  bankAccounts: BankPaymentOption;
  loading: boolean;
  onboardingDetails: null | OnboardingDetails,
}

export interface PaymentProviderCardDetails {
  id: string;
  card_last_4: string;
}
